<template>
  <!--
<Menubar :model="items" />
-->
  <div>
    <Menubar :model="items" class="bg-white border-3 shadow-4 mb-2">
      <template #start>
        <!--
        <button class="pi pi-home" >
             <NuxtLink to="/">&nbsp;ログイン</NuxtLink>          
        </button>
        <button  class="pi pi-home" >
             <NuxtLink to="/area">&nbsp;エリア</NuxtLink>          
        </button>  
        -->
        <TabMenu :model="itemsTabs" />
      </template>

      <template #end>
        <div>
          <button
            class="pi pi-question-circle bg-white border-none text-lg"
            @click="toManual"
          >
            使い方
          </button>
          <button class="pi bg-white border-none"></button>
          <button
            v-if="isLoggedIn"
            class="pi pi-power-off bg-white border-none text-lg"
            @click="handleSignOut"
          >
            ログアウト
          </button>

          <button
            v-else
            class="pi pi-power-off bg-white border-none no-underline"
          >
            <NuxtLink
              to="/auth"
              class="bg-white border-none no-underline text-lg"
              >&nbsp;ログイン</NuxtLink
            >
          </button>
        </div>
        <div></div>
      </template>
    </Menubar>

    <!--
<pre>
    {{isLoggedIn}}
   user = {{loginuser}}
</pre>
-->
    <!--

<div class="navbar bg-base-100">
  <div class="navbar-start">

    <div class="dropdown">
      <label tabindex="0" class="btn btn-ghost lg:hidden">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
      </label>
      <ul tabindex="0" class="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
        <li><a>Item 1</a></li>
        <li tabindex="0">
          <a class="justify-between">
            Parent
            <svg class="fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"/></svg>
          </a>
          <ul class="p-2">
            <li><a>Submenu 1</a></li>
            <li><a>Submenu 2</a></li>
          </ul>
        </li>
        <li><a>Item 3</a></li>
      </ul>
    </div>
    <a class="btn btn-ghost normal-case text-xl">daisyUI</a>

    <div class="tabs">
    <a class="tab tab-lifted">Tab 1</a> 
    <a class="tab tab-lifted tab-active">Tab 2</a> 
    <a class="tab tab-lifted">Tab 3</a>
    </div>

  </div>

  <div class="navbar-center hidden lg:flex">
    <ul class="menu menu-horizontal p-0">
      <li><a>Item 1</a></li>
      <li tabindex="0">
        <a>
          Parent
          <svg class="fill-current" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"/></svg>
        </a>
        <ul class="p-2">
          <li><a>Submenu 1</a></li>
          <li><a>Submenu 2</a></li>
        </ul>
      </li>
      <li><a>Item 3</a></li>
    </ul>
  </div>
  <div class="navbar-end">
    <a class="btn" @click="handleSignOut">ログアウト</a>
  </div>
  <div>
     
  </div>
</div>

-->

    <slot />
  </div>
</template>

<script lang="ts" setup>
import type { User, Subscription } from "@supabase/supabase-js";
const subscription = ref<{ data: Subscription | null }>();
const { $supabase } = useNuxtApp();
const router = useRouter();
// const loginuser = useUser()
const loginuser = useUser();
const isLoggedIn = computed(() => {
  return !!loginuser.value;
});

const client = useSupabaseClient();

loginuser.value = useSupabaseUser();
client.auth.onAuthStateChange((_, session) => {
  user.value = session?.user;
});

/*
    const route = useRoute()
    watch(() => route.query, () => refresh())
*/

// wanna to get the state on the server ?
// const user = useState('user')
// if(process.server && !user.value) { /* on server, not authenticated */ }

// wanna get state on the client? Populate a ref on `onMounted`
const user = ref<User | null>(null);

// you can also use the API routes to retreive the logged-in user
// @ts-ignore
// const { data } = await useAsyncData('user', () => $fetch<{user: User}>('/api/me'), { server: true }) // on server + client , not authenticated

const handleSignOut = async () => {
  console.log("calles");
  // await $supabase.auth.signOut()
  await client.auth.signOut();
  router.replace("/auth");
};

const toManual = () => {
  const url = "https://wiki3.jp/nitrate/page/6";
  window.open(url, "_blank");
};

/*
    onMounted(() => {
        user.value = $supabase.auth.user()
        if(!user.value) {
            router.replace('/auth')
        }
        subscription.value = $supabase.auth.onAuthStateChange(async(event, session) => {
            await $fetch('/api/auth', {
                method: 'POST',
                body: { event, session }
            })
        })
    })

    onUnmounted(() => {
        if(subscription.value) subscription.value?.data?.unsubscribe()
    })
*/

const itemsTabs = ref([
  { label: "Home", icon: "pi pi-fw pi-home", to: "/" },
  { label: "土壌診断", icon: "pi pi-fw pi-calendar", to: "/measurements" },
  { label: "区画", icon: "pi pi-fw pi-calendar", to: "/area" },
  { label: "肥料", icon: "pi pi-fw pi-file", to: "/fertilizer" },
  { label: "野菜", icon: "pi pi-fw pi-pencil", to: "/vegetables" },
  /*
  { label: 'Settings', icon: 'pi pi-fw pi-cog', to: '/signout' },
*/
  { label: "ユーザ", icon: "pi pi-fw pi-user", to: "/profile" },
]);

const items = ref();
/*[
                {
					label:'File',
					icon:'pi pi-fw pi-file',
					items:[
						{
							label:'New',
							icon:'pi pi-fw pi-plus',
							items:[
								{
									label:'Bookmark',
									icon:'pi pi-fw pi-bookmark'
								},
								{
									label:'Video',
									icon:'pi pi-fw pi-video'
								}
							]
						},
						{
							label:'Delete',
							icon:'pi pi-fw pi-trash'
						},
						{
							separator:true
						},
						{
							label:'Export',
							icon:'pi pi-fw pi-external-link'
						}
					]
        },
                
        ]
        */
</script>
